export var ACTION;
(function (ACTION) {
    ACTION["FETCH_MY_PORTFOLIO"] = "FETCH_MY_PORTFOLIO";
    ACTION["LOGOUT"] = "LOGOUT";
    ACTION["FAQ"] = "FAQ";
    ACTION["SHOW_EDIT_LIMIT"] = "SHOW_EDIT_LIMIT";
    ACTION["CONTINUE_APPLICATION"] = "CONTINUE_APPLICATION";
    ACTION["CONTINUE_EDIT_LIMIT"] = "CONTINUE_EDIT_LIMIT";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["NAVIGATE_PROFILE"] = "NAVIGATE_PROFILE";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["NAV_TO_IC"] = "NAV_TO_IC";
})(ACTION || (ACTION = {}));
